<div
  class="header-search"
  [class.header-search--open]="panelOpen"
  (mousedown)="onSearchShellPointerDown($event)">
  <mat-form-field
    appearance="outline"
    color="primary"
    class="hide-hint header-search__field"
    subscriptSizing="dynamic">
    <span matPrefix class="header-search__prefix" aria-hidden="true">
      <mat-icon>search</mat-icon>
    </span>
    <input
      #searchInput
      matInput
      type="text"
      autocomplete="off"
      [placeholder]="'header.search_placeholder' | translate"
      [formControl]="searchControl"
      [attr.aria-expanded]="panelOpen"
      aria-controls="header-search-panel"
      (focus)="onInputFocus()"
      (input)="onSearchInput()"
      (keydown)="onInputKeydown($event)" />
    <span matSuffix class="header-search__shortcut" aria-hidden="true">Ctrl+K</span>
  </mat-form-field>

  @if (panelOpen) {
  <div id="header-search-panel" class="header-search__panel cardWithShadow" (mousedown)="$event.preventDefault()">
    @if (!hasQuery) {
    @if (recentSearches.length > 0) {
    <div class="header-search__recent">
      <div class="header-search__recent-header">
        <p class="header-search__recent-title">{{ 'header.recent_searches' | translate }}</p>
        <button mat-button type="button" class="header-search__clear-btn" (click)="clearAllHistory()">
          <span>{{ 'header.clear_history' | translate }}</span>
        </button>
      </div>
      <div class="header-search__recent-items">
        @for (search of recentSearches; track search.timestamp) {
        <button type="button" class="header-search__recent-item" (click)="selectRecentSearch(search.query)">
          <span class="header-search__item-icon header-search__item-icon--muted" aria-hidden="true">
            <i-tabler name="history" class="d-flex"></i-tabler>
          </span>
          <div class="header-search__recent-content">
            <span class="header-search__recent-query">{{ search.query }}</span>
            <span class="header-search__recent-count">
              {{ search.resultCount }} {{ 'header.results' | translate }}
            </span>
          </div>
          <button
            mat-icon-button
            type="button"
            class="header-search__delete-btn"
            [attr.aria-label]="'header.clear_history' | translate"
            (click)="removeRecentSearch($event, search.query)">
            <mat-icon>delete</mat-icon>
          </button>
        </button>
        }
      </div>
    </div>
    } @else {
    <div class="header-search__empty">
      <i-tabler name="search" class="header-search__empty-icon"></i-tabler>
      <p class="header-search__empty-text">{{ 'header.search_placeholder' | translate }}</p>
      <p class="header-search__empty-subtext">{{ 'header.search_hint' | translate }}</p>
    </div>
    }
    } @else if (filteredResults.length > 0) {
    <div class="header-search__results">
      <h4 class="header-search__results-title">
        {{ 'header.quick_links' | translate }} ({{ filteredResults.length }})
      </h4>
      <div class="header-search__results-list">
        @for (item of filteredResults; track item.displayName) {
        <a
          [routerLink]="[item.route]"
          class="header-search__result-item"
          (click)="onResultSelected()">
          <span class="header-search__item-icon" aria-hidden="true">
            @if (item.iconName) {
            <i-tabler [name]="item.iconName" class="d-flex"></i-tabler>
            }
          </span>
          <div class="header-search__result-content">
            <h5 class="header-search__result-title">
              {{ ('side_menu.' + item.displayName) | translate }}
            </h5>
            @if (item.shortDescription) {
            <span class="header-search__result-description">
              {{ item.shortDescription | translate }}
            </span>
            }
          </div>
          @if (item.Description) {
          <i-tabler
            name="info-circle"
            class="header-search__result-action header-search__result-info d-flex"
            [matTooltip]="item.Description | translate"
            matTooltipPosition="left"
            (click)="$event.preventDefault(); $event.stopPropagation()"></i-tabler>
          }
          <i-tabler name="chevron-right" class="header-search__result-action header-search__result-arrow d-flex"></i-tabler>
        </a>
        }
      </div>
    </div>
    } @else {
    <div class="header-search__empty">
      <i-tabler name="search-off" class="header-search__empty-icon"></i-tabler>
      <p class="header-search__empty-text">{{ 'header.no_results' | translate }}</p>
    </div>
    }
  </div>
  }
</div>
